import { find } from 'lodash-es';

/**
 * Returns chosen hotel offer.
 */
export const getChosenHotelData = (xCode: string | null, hotels: any[]) => find(hotels, { groupKeyValue: xCode });
